import configApi from './_api'
// TODO: Restore versioning when is implemented in api
// import { getDataFromLocalStorage, setDataToLocalStorage } from './_utils/localStorageManagement'
export default {
  fetchZohoPlans: async ({ commit }) => {
    try {
      const response = await configApi.getZohoPlans()
      commit('setZohoPlans', response.data)
    } catch (error) {
      console.error(error)
      throw (error)
    }
  },
  fetchPublicConfig: async ({ getters, commit, dispatch }, initial = false) => {
    if (getters.isCallingConfig && !initial) return
    commit('setIsCallingConfig', true)

    try {
      const response = await configApi.getPublicConfig()
      commit('setPublicConfig', response.data)
      // setDataToLocalStorage('publicConfig', getters.publicConfigVersion, response.data)
    } catch (error) {
      console.error(error)
      throw (error)
    } finally {
      commit('setIsCallingConfig', false)
    }
  },
  fetchPrivateConfig: async ({ getters, commit, dispatch }, initial = false) => {
    if (getters.isCallingConfig && !initial) return
    commit('setIsCallingConfig', true)
    /*
    const privateConfiguration = getDataFromLocalStorage('privateConfig', getters.privateConfigVersion)
    if (privateConfiguration) {
      commit('setPrivateConfig', privateConfiguration)
      commit('setIsCallingConfig', false)
      return
    } */
    try {
      const response = await configApi.getPrivateConfig()
      commit('setPrivateConfig', response.data)
      // setDataToLocalStorage('privateConfig', getters.privateConfigVersion, response.data)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit('setIsCallingConfig', false)
    }
  },
  fetchCurrencies: async ({ getters, commit, dispatch }, initial = false) => {
    commit('setIsCallingConfig', true)
    try {
      const response = await configApi.getCurrencies()
      commit('setCurrencies', response.data)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit('setIsCallingConfig', false)
    }
  }

}
